import { type AxiosRequestConfig } from 'axios'

const changePassword = (data: any): AxiosRequestConfig => {
  return {
    method: 'POST',
    url: '/user/change-password',
    data: data
  }
}

export { changePassword }
